import { ref, watch, computed } from '@vue/composition-api'

// Notification
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import axios from 'axios'
import Vue from 'vue'
import router from '../../../router'

export default function useMaterialRequestsList() {
  const toast = useToast()
  const refPurchaseOrderListTable = ref(null)
  const refPurchaseOrderListTableFinished = ref(null)
  const refPurchaseOrderListTableHO = ref(null)
  const refPurchaseOrderListTableFinishedHO = ref(null)
  const refPurchaseOrderListTablePaid = ref(null)
  const tableColumns = [
    { key: 'Number', sortable: true },
    { key: 'IssuedDate', sortable: true },
    { key: 'ReceivedDate', sortable: true },
    { key: 'TOP', sortable: false },
    { key: 'DueDate', sortable: true },
    { key: 'SupplierName', sortable: true },
    { key: 'Bill', sortable: true },
    { key: 'Tax', sortable: true },
    { key: 'TransportFee', sortable: true },
    { key: 'TotalBill', sortable: true },
    { key: 'Action', sortable: true },
  ]
  const tableColumnsPaid = [
    { key: 'Number', sortable: true },
    { key: 'IssuedDate', sortable: true },
    { key: 'ReceivedDate', sortable: true },
    { key: 'TOP', sortable: false },
    { key: 'DueDate', sortable: true },
    { key: 'SupplierName', sortable: true },
    { key: 'Bill', sortable: true },
    { key: 'Tax', sortable: true },
    { key: 'TotalBill', sortable: true },
    { key: 'Action', sortable: true },
  ]
  const perPage = ref(10)
  const perPageHO = ref(10)
  const perPageFinished = ref(10)
  const perPageFinishedHO = ref(10)
  const perPagePaid = ref(10)
  const totalPurchaseOrder = ref(0)
  const totalPurchaseOrderHO = ref(0)
  const totalPurchaseOrderFinished = ref(0)
  const totalPurchaseOrderFinishedHO = ref(0)
  const totalPurchaseOrderPaid = ref(0)
  const currentPage = ref(1)
  const currentPageHO = ref(1)
  const currentPageFinished = ref(1)
  const currentPageFinishedHO = ref(1)
  const currentPagePaid = ref(1)
  const perPageOptions = [10, 25, 50, 100]
  const searchQuery = ref('')
  const searchQueryHO = ref('')
  const searchQueryFinished = ref('')
  const searchQueryFinishedHO = ref('')
  const searchQueryPaid = ref('')
  const sortBy = ref('id')
  const sortByHO = ref('id')
  const sortByFinished = ref('id')
  const sortByFinishedHO = ref('id')
  const sortByPaid = ref('id')
  const isSortDirDesc = ref(true)
  const isSortDirDescHO = ref(true)
  const isSortDirDescFinished = ref(true)
  const isSortDirDescFinishedHO = ref(true)
  const isSortDirDescPaid = ref(true)
  const roleFilter = ref(null)
  const statusFilter = ref(null)
  const startDateFilter = ref('')
  const endDateFilter = ref('')
  const dueDateFilter = ref('')
  const startDateFilterHO = ref('')
  const endDateFilterHO = ref('')
  const startDateFilterFinished = ref('')
  const endDateFilterFinished = ref('')
  const startDateFilterFinishedHO = ref('')
  const endDateFilterFinishedHO = ref('')
  const startDateFilterPaid = ref('')
  const endDateFilterPaid = ref('')

  const dataMeta = computed(() => {
    const localItemsCount = refPurchaseOrderListTable.value ? refPurchaseOrderListTable.value.localItems.length : 0
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalPurchaseOrder.value,
    }
  })

  const dataMetaHO = computed(() => {
    const localItemsCount = refPurchaseOrderListTableHO.value ? refPurchaseOrderListTableHO.value.localItems.length : 0
    return {
      from: perPageHO.value * (currentPageHO.value - 1) + (localItemsCount ? 1 : 0),
      to: perPageHO.value * (currentPageHO.value - 1) + localItemsCount,
      of: totalPurchaseOrderHO.value,
    }
  })

  const dataMetaFinished = computed(() => {
    const localItemsCount = refPurchaseOrderListTableFinished.value ? refPurchaseOrderListTableFinished.value.localItems.length : 0
    return {
      from: perPageFinished.value * (currentPageFinished.value - 1) + (localItemsCount ? 1 : 0),
      to: perPageFinished.value * (currentPageFinished.value - 1) + localItemsCount,
      of: totalPurchaseOrderFinished.value,
    }
  })
  const dataMetaFinishedHO = computed(() => {
    const localItemsCount = refPurchaseOrderListTableFinishedHO.value ? refPurchaseOrderListTableFinishedHO.value.localItems.length : 0
    return {
      from: perPageFinishedHO.value * (currentPageFinishedHO.value - 1) + (localItemsCount ? 1 : 0),
      to: perPageFinishedHO.value * (currentPageFinishedHO.value - 1) + localItemsCount,
      of: totalPurchaseOrderFinishedHO.value,
    }
  })

  const dataMetaPaid = computed(() => {
    const localItemsCount = refPurchaseOrderListTablePaid.value ? refPurchaseOrderListTablePaid.value.localItems.length : 0
    return {
      from: perPagePaid.value * (currentPagePaid.value - 1) + (localItemsCount ? 1 : 0),
      to: perPagePaid.value * (currentPagePaid.value - 1) + localItemsCount,
      of: totalPurchaseOrderPaid.value,
    }
  })

  const refetchData = () => {
    refPurchaseOrderListTable.value.refresh()
  }

  const refetchDataHO = () => {
    refPurchaseOrderListTableHO.value.refresh()
  }

  const refetchDataFinished = () => {
    refPurchaseOrderListTableFinished.value.refresh()
  }
  const refetchDataFinishedHO = () => {
    refPurchaseOrderListTableFinishedHO.value.refresh()
  }

  const refetchDataPaid = () => {
    refPurchaseOrderListTablePaid.value.refresh()
  }

  watch([currentPage, currentPageHO, currentPageFinished, currentPageFinishedHO, currentPagePaid, perPage, perPageHO, perPageFinished, perPageFinishedHO, perPagePaid, searchQuery, searchQueryHO, searchQueryFinished, searchQueryFinishedHO, searchQueryPaid, roleFilter, statusFilter, sortBy, sortByHO, sortByFinished, sortByFinishedHO, sortByPaid, isSortDirDesc, isSortDirDescHO, isSortDirDescFinished, isSortDirDescFinishedHO, isSortDirDescPaid, startDateFilter, startDateFilterHO, startDateFilterFinished, startDateFilterFinishedHO, startDateFilterPaid, endDateFilter, endDateFilterHO, endDateFilterFinished, endDateFilterFinishedHO, endDateFilterPaid, dueDateFilter], () => {
    refetchData()
    refetchDataFinished()
    refetchDataHO()
    refetchDataFinishedHO()
    refetchDataPaid()
  })

  const fetchPurchaseOrders = (ctx, callback) => {
    const userToken = Vue.$cookies.get('userToken')
    const to = perPage.value * (currentPage.value - 1)
    const headers = {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${userToken}`,
    }
    axios
      .get(`${process.env.VUE_APP_API_URL}${process.env.VUE_APP_API_GET_PURCHASE_ORDER}?limit=${perPage.value}&offset=${to}&date_start=${startDateFilter.value}&date_end=${endDateFilter.value}&due_date=${dueDateFilter.value}&search=${searchQuery.value}&is_paid=false&status=finished`, { headers })
      .then(response => {
        totalPurchaseOrder.value = response.data.data_count
        callback(response.data.data)
      })
      .catch(e => {
        if (e.message === 'Request failed with status code 401') {
         router.push({ name: 'auth-login' })
        } else {
          console.log(e)
          toast({
            component: ToastificationContent,
            props: {
              title: 'Error fetching data list',
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
        }
      })
  }
  const fetchPurchaseOrdersHO = (ctx, callback) => {
    const userToken = Vue.$cookies.get('userToken')
    const to = perPageHO.value * (currentPageHO.value - 1)
    const headers = {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${userToken}`,
    }
    axios
      .get(`${process.env.VUE_APP_API_URL}${process.env.VUE_APP_API_GET_PURCHASE_ORDER}?limit=${perPageHO.value}&offset=${to}&status=ongoing&date_start=${startDateFilter.value}&date_end=${endDateFilter.value}&search=${searchQuery.value}&is_center=true`, { headers })
      .then(response => {
        totalPurchaseOrderHO.value = response.data.data_count
        callback(response.data.data)
      })
      .catch(e => {
        if (e.message === 'Request failed with status code 401') {
         router.push({ name: 'auth-login' })
        } else {
          console.log(e)
          toast({
            component: ToastificationContent,
            props: {
              title: 'Error fetching data list',
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
        }
      })
  }

  const fetchPurchaseOrdersFinished = (ctx, callback) => {
    const userToken = Vue.$cookies.get('userToken')
    const to = perPageFinished.value * (currentPageFinished.value - 1)
    const headers = {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${userToken}`,
    }
    axios
      .get(`${process.env.VUE_APP_API_URL}${process.env.VUE_APP_API_GET_PURCHASE_ORDER}?limit=${perPageFinished.value}&offset=${to}&status=finished&date_start=${startDateFilterFinished.value}&date_end=${endDateFilterFinished.value}&search=${searchQueryFinished.value}`, { headers })
      .then(response => {
        totalPurchaseOrderFinished.value = response.data.data_count
        callback(response.data.data)
      })
      .catch(e => {
        if (e.message === 'Request failed with status code 401') {
         router.push({ name: 'auth-login' })
        } else {
          console.log(e)
          toast({
            component: ToastificationContent,
            props: {
              title: 'Error fetching data list',
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
        }
      })
  }

  const fetchPurchaseOrdersFinishedHO = (ctx, callback) => {
    const userToken = Vue.$cookies.get('userToken')
    const to = perPageFinishedHO.value * (currentPageFinishedHO.value - 1)
    const headers = {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${userToken}`,
    }
    axios
      .get(`${process.env.VUE_APP_API_URL}${process.env.VUE_APP_API_GET_PURCHASE_ORDER}?limit=${perPageFinishedHO.value}&offset=${to}&status=finished&date_start=${startDateFilterFinishedHO.value}&date_end=${endDateFilterFinishedHO.value}&search=${searchQueryFinishedHO.value}&is_center=true`, { headers })
      .then(response => {
        totalPurchaseOrderFinishedHO.value = response.data.data_count
        callback(response.data.data)
      })
      .catch(e => {
        if (e.message === 'Request failed with status code 401') {
         router.push({ name: 'auth-login' })
        } else {
          console.log(e)
          toast({
            component: ToastificationContent,
            props: {
              title: 'Error fetching data list',
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
        }
      })
  }

  const fetchPurchaseOrdersPaid = (ctx, callback) => {
    const userToken = Vue.$cookies.get('userToken')
    const to = perPagePaid.value * (currentPagePaid.value - 1)
    const headers = {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${userToken}`,
    }
    axios
      .get(`${process.env.VUE_APP_API_URL}${process.env.VUE_APP_API_GET_PURCHASE_ORDER}?limit=${perPagePaid.value}&offset=${to}&date_start=${startDateFilterPaid.value}&date_end=${endDateFilterPaid.value}&search=${searchQueryPaid.value}&is_paid=true&status=finished`, { headers })
      .then(response => {
        totalPurchaseOrderPaid.value = response.data.data_count
        callback(response.data.data)
      })
      .catch(e => {
        if (e.message === 'Request failed with status code 401') {
         router.push({ name: 'auth-login' })
        } else {
          console.log(e)
          toast({
            component: ToastificationContent,
            props: {
              title: 'Error fetching data list',
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
        }
      })
  }

  const fetchRoles = () => {
    const userToken = Vue.$cookies.get('userToken')
    const headers = {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${userToken}`,
    }
    axios
      .get(`${process.env.VUE_APP_API_URL}${process.env.VUE_APP_API_GET_ROLES}`, { headers })
      .then(response => {
        console.log(response)
        const temp = [
          { label: 'Admin', value: 'admin' },
          { label: 'Author', value: 'author' },
          { label: 'Editor', value: 'editor' },
          { label: 'Maintainer', value: 'maintainer' },
          { label: 'Subscriber', value: 'subscriber' },
        ]
        return temp
      })
      .catch(() => {
        toast({
          component: ToastificationContent,
          props: {
            title: 'Error fetching role list',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      })
  }

  // *===============================================---*
  // *--------- UI ---------------------------------------*
  // *===============================================---*

  const resolveUserRoleVariant = role => {
    if (role === 'subscriber') return 'primary'
    if (role === 'author') return 'warning'
    if (role === 'maintainer') return 'success'
    if (role === 'editor') return 'info'
    if (role === 'super-admin') return 'danger'
    return 'primary'
  }

  const resolveUserRoleIcon = role => {
    if (role === 'subscriber') return 'UserIcon'
    if (role === 'author') return 'SettingsIcon'
    if (role === 'maintainer') return 'DatabaseIcon'
    if (role === 'editor') return 'Edit2Icon'
    if (role === 'super-admin') return 'ServerIcon'
    return 'UserIcon'
  }

  const resolveUserStatusVariant = status => {
    if (status === 'pending') return 'warning'
    if (status === 'active') return 'success'
    if (status === 'inactive') return 'secondary'
    return 'primary'
  }

  return {
    fetchPurchaseOrders,
    fetchPurchaseOrdersHO,
    fetchPurchaseOrdersFinished,
    fetchPurchaseOrdersFinishedHO,
    fetchPurchaseOrdersPaid,
    fetchRoles,
    tableColumns,
    tableColumnsPaid,
    perPage,
    perPageFinished,
    perPagePaid,
    currentPage,
    currentPageFinished,
    currentPagePaid,
    totalPurchaseOrder,
    totalPurchaseOrderFinished,
    totalPurchaseOrderPaid,
    dataMeta,
    dataMetaFinished,
    dataMetaPaid,
    perPageOptions,
    searchQuery,
    searchQueryFinished,
    searchQueryPaid,
    sortBy,
    sortByFinished,
    sortByPaid,
    isSortDirDesc,
    isSortDirDescFinished,
    isSortDirDescPaid,
    refPurchaseOrderListTable,
    refPurchaseOrderListTableFinished,
    refPurchaseOrderListTablePaid,
    resolveUserRoleVariant,
    resolveUserRoleIcon,
    resolveUserStatusVariant,
    refetchData,
    refetchDataFinished,
    refetchDataPaid,
    // Extra Filters
    roleFilter,
    statusFilter,
    startDateFilter,
    endDateFilter,
    dueDateFilter,
    startDateFilterFinished,
    endDateFilterFinished,
    startDateFilterPaid,
    endDateFilterPaid,
    perPageHO,
    perPageFinishedHO,
    currentPageHO,
    currentPageFinishedHO,
    totalPurchaseOrderHO,
    totalPurchaseOrderFinishedHO,
    dataMetaHO,
    dataMetaFinishedHO,
    searchQueryHO,
    searchQueryFinishedHO,
    sortByHO,
    sortByFinishedHO,
    isSortDirDescHO,
    isSortDirDescFinishedHO,
    refPurchaseOrderListTableHO,
    refPurchaseOrderListTableFinishedHO,
  }
}
